import { useMemo } from 'react';

import { useMapContextRedistributor } from 'app/contexts/MapContextRedistributor/mapContextRedistributorProvider';

import { SplitFeatures } from 'app/global/features';

import useTreatment from 'app/hooks/useTreatment';

import { HierarchyType } from 'app/models';

const FALLBACK_THRESHOLD = 200_000;

export const usePinsWarningThreshold = (): number => {
  const [_isFlagOn, { config: accountMapWarningConfig }] = useTreatment(SplitFeatures.ACCOUNT_MAP_WARNING);
  const { primaryHierarchy } = useMapContextRedistributor();

  return useMemo(() => {
    if (!accountMapWarningConfig) return FALLBACK_THRESHOLD;
    try {
      const configObject: ExpectedConfigObject = JSON.parse(accountMapWarningConfig);
      if (primaryHierarchy === HierarchyType.CustomerAccountHierarchy) {
        return configObject.accountFirstPinsWarningThreshold ?? FALLBACK_THRESHOLD;
      }
      return configObject.geoFirstPinsWarningThreshold ?? FALLBACK_THRESHOLD;
    } catch (error) {
      console.error('Unable to determine pin warning threshold from config', error);
      return FALLBACK_THRESHOLD;
    }
  }, [accountMapWarningConfig, primaryHierarchy]);
};

type ExpectedConfigObject = {
  accountFirstPinsWarningThreshold?: number | null;
  geoFirstPinsWarningThreshold?: number | null;
};
